import { HttpHelper, HttpServiceParams } from '@ppvrbh/merchant-frontend-core';
import { FOODMENU_REQUEST_ID_LIST } from './foodmenu-constant';

class FoodMenuServiceClass {
  getFoodMenus = async () => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/menus?showModifierGroups=true',
      id: FOODMENU_REQUEST_ID_LIST.GET_FOOD_MENU
    });
  }

  postFoodMenus = async (params: HttpServiceParams) => {
    return await HttpHelper.post({
      url: 'v2/merchant/company-admin/menus',
      data: params.data,
      id: FOODMENU_REQUEST_ID_LIST.POST_FOOD_MENU
    });
  }

  patchFoodMenus = async (params: HttpServiceParams) => {
    return await HttpHelper.patch({
      url: 'v2/merchant/company-admin/menus',
      data: params.data,
      id: FOODMENU_REQUEST_ID_LIST.PATCH_FOOD_MENU
    });
  }

  deleteFoodMenus = async (params: HttpServiceParams) => {
    return await HttpHelper.delete({
      url: 'v2/merchant/company-admin/menus',
      config: { headers: { menuId: params.data } },
      id: FOODMENU_REQUEST_ID_LIST.DELETE_FOOD_MENU
    });
  }

  getMenuTags = async (params: HttpServiceParams) => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/menus/tags',
      id: params.id
    });
  }
  
  getFoodQcKeyword = async () => {
    return await HttpHelper.get({
      url: 'v1/merchant/company-admin/food-qc/keyword',
      id: FOODMENU_REQUEST_ID_LIST.GET_FOOD_QC_KEYWORD
    });
  }
}

export const FoodMenuService = new FoodMenuServiceClass();
